import { useWatch } from 'react-hook-form';
import FormField from '../FormField';
import { jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
export default function FormRelatedFields(_ref) {
  var fieldName = _ref.fieldName,
    relatedFields = _ref.relatedFields,
    control = _ref.control,
    errors = _ref.errors,
    getValues = _ref.getValues,
    handleSetValue = _ref.handleSetValue,
    handleResetField = _ref.handleResetField,
    handleSetError = _ref.handleSetError,
    handleClearErrors = _ref.handleClearErrors,
    reset = _ref.reset;
  var selectedValue = useWatch({
    name: fieldName,
    control
  });
  if (!!relatedFields && !!selectedValue) {
    var _relatedFields$select, _relatedFields$select2;
    return _jsx(_Fragment, {
      children: (_relatedFields$select = relatedFields[selectedValue]) === null || _relatedFields$select === void 0 || (_relatedFields$select2 = _relatedFields$select.map) === null || _relatedFields$select2 === void 0 ? void 0 : _relatedFields$select2.call(_relatedFields$select, field => {
        var _field$id;
        return _jsx(FormField, {
          control: control,
          formField: field,
          errors: errors,
          handleSetValue: handleSetValue,
          handleResetField: handleResetField,
          handleSetError: handleSetError,
          handleClearErrors: handleClearErrors,
          getValues: getValues,
          reset: reset
        }, "".concat(field.name, "-").concat((_field$id = field.id) !== null && _field$id !== void 0 ? _field$id : ''));
      })
    });
  }
  return null;
}